export const titleCase = (text: string): string =>
  text
    .split('_')
    .reduce((acc, item) => {
      if (item.length) {
        acc = `${acc} ${item[0]?.toUpperCase() + item.slice(1).toLowerCase()}`;
      }
      return acc;
    }, '')
    .trimStart();

export function formatUnderscoreString(str: string): string {
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1))
    .join(' ');
}

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const statusFormatter = (status: string): string => status.replaceAll('_', ' ');

// Cyrillic character ranges - moved outside character class per SonarQube
const CYRILLIC_PATTERN = /[Ѐ-ӿԀ-ԯⷠ-ⷿꙀ-ꚟᲀ-᲏]/g;

export const inputNormalizer = (s: string): string =>
  s.normalize('NFKC').replace(CYRILLIC_PATTERN, '').replace(/[.,]/g, '').replace(/\s+/g, ' ').trim();

export const inputSanitizer = (s: string): string =>
  s.normalize('NFKC').replace(CYRILLIC_PATTERN, '').replace(/[.,]/g, '');
